import { ForgotPasswordBody } from "../../domain/entities/forgot-password-entity";
import { HttpClient } from "../../../../shared/infrastructure";
import { UseMutationResult, useMutation } from "@tanstack/react-query";

const FORGOT_PASSWORD_ENDPOINT = "auth/forgot-password";

const useForgotPassword = (): UseMutationResult<
  void,
  unknown,
  ForgotPasswordBody
> => {
  return useMutation(
    async (body: ForgotPasswordBody) =>
      (await HttpClient.post<void>(FORGOT_PASSWORD_ENDPOINT, body)).data
  );
};

export { useForgotPassword };
